import { api } from './api';
import type { Task, CreateTaskInput, TaskPriority, TaskStatus } from '@traaker/shared';

export const tasksApi = {
  list: (brandId?: string) => {
    const params = brandId ? `?brandId=${brandId}` : '';
    return api.get<Task[]>(`/tasks${params}`);
  },

  getById: (taskId: string) =>
    api.get<Task>(`/tasks/${taskId}`),

  create: (input: CreateTaskInput & { brandId?: string }) =>
    api.post<Task>('/tasks', input),

  updateStatus: (taskId: string, status: TaskStatus) =>
    api.patch<Task>(`/tasks/${taskId}/status`, { status }),

  update: (taskId: string, updates: { priority?: TaskPriority; assigneeId?: string; dueDate?: string }) =>
    api.patch<Task>(`/tasks/${taskId}`, updates),

  delete: (taskId: string) =>
    api.delete<{ success: boolean }>(`/tasks/${taskId}`),

  verify: (taskId: string) =>
    api.post<Task>(`/tasks/${taskId}/verify`, {}),
};
